import React, { useEffect } from "react";
import CarouselSection from "../../Carousel";
import Typed from "typed.js";
import { Button } from "reactstrap";
import { useNavigate } from "react-router";

const Header = () => {
  const navigate = useNavigate();

  useEffect(() => {
    new Typed("#typed", {
      strings: [
        "Surveillance,",
        "Monitoring, ",
        "and Evaluation(SME)",
        "and",
        "Geospatial Applications"
      ],
      typeSpeed: 150,
      backSpeed: 60,
      backDelay: 2000,
      startDelay: 500,
      loop: true,
    });

    return () => {};
  }, []);
  return (
    <header className="header-2">
      <CarouselSection />
      <div className="page-header section-height-85 position-absolute top-0 w-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 text-center mx-auto">
              <h3 className="text-white programme-title font-weight-bolder">
                International Short Course on Surveillance, Monitoring, Evaluation (SME) and Geospatial Applications in Malaria Programme
              </h3>
              <h3 className="text-white mt-n2">
                <span className='highlighted' id="typed" />
              </h3>
              <p className={"text-white"}>
                August 19 – September 6, 2024 | AFENET Ghana
              </p>
              <div className="container d-lg-none">
                <div className="row justify-content-center">
                  <div className="col-lg-8 text-center mx-auto my-auto mt-4">
                    <Button
                      className="btn-round btn-primary me-2 bg-white text-dark"
                      size="lg"
                      onClick={() => navigate("/sign-up")}
                    >
                      Click Here To Apply
                    </Button>
                    <Button
                      className="btn-round bg-gradient-dark"
                      size="lg"
                      onClick={() => {
                        window.location.href = "https://smeproje.web.app";
                      }}
                    >
                      Login
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute w-100 z-index-2 bottom-0">
          <svg
            className="waves z-index-3"
            preserveAspectRatio="none"
            shapeRendering="auto"
            viewBox="0 24 150 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <path
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                id="gentle-wave"
              />
            </defs>
            <g className="moving-waves">
              <use
                fill="rgba(255,255,255,0.40"
                x="48"
                xlinkHref="#gentle-wave"
                y="-1"
              />
              <use
                fill="rgba(255,255,255,0.35)"
                x="48"
                xlinkHref="#gentle-wave"
                y="3"
              />
              <use
                fill="rgba(255,255,255,0.25)"
                x="48"
                xlinkHref="#gentle-wave"
                y="5"
              />
              <use
                fill="rgba(255,255,255,0.20)"
                x="48"
                xlinkHref="#gentle-wave"
                y="8"
              />
              <use
                fill="rgba(255,255,255,0.15)"
                x="48"
                xlinkHref="#gentle-wave"
                y="13"
              />
              <use
                fill="rgba(255,255,255,0.95"
                x="48"
                xlinkHref="#gentle-wave"
                y="16"
              />
            </g>
          </svg>
        </div>
      </div>
    </header>
  );
};

export default Header;
